import Icon from '../../components/Icon.vue'

Icon.register({"brands/stack-overflow":{"width":384,"height":512,"paths":[{"d":"M293.7 300L112.5 215.5 129.2 179 310.5 263.7 293.7 300zM341.7 224L188.2 95.7 162.7 126.5 316.2 254.8 341.7 224zM381.3 192.3L262 32 230 56 349.3 216.3 381.3 192.3zM290.7 311L95 269.7 86.8 309 282.5 350 290.7 311zM322.3 440H42.7V320H2.7V480H362.2V320H322.2V440zM282.5 360H82.5V399.7H282.5V360z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/stack-overflow.js
// module id = null
// module chunks = 